import React, { Suspense, useState, useEffect } from "react";
import { Modal } from 'react-responsive-modal';
import AccountingRecognition_Template from "./AccountingRecognition_Template";
import ReportsServices from './ReportsServices';
import { CommonUtilities } from '../../commonUtils';
import korrectLogo from '../../assets/images/korrectLogoIcon.png';
import BasicReport from "./BasicReport";

export default function Reports(subEntity: any) {

    let [ReportMenu, setReportMenu] = useState(false);
    let [activeMenu, setActiveMenu] = useState("Basic Report");
    let [activeSubTab, setactiveSubTab] = useState("");

    const getReportMenu = () => {

        ReportsServices.ReportMenu().then((res) => {
            console.log(res)

            setReportMenu(res);

        });

    }

    const closeModal = (e: any) => {
        const modal = document.getElementById("myModal") as HTMLElement;
        modal?.classList.remove("displayItem");
        modal?.classList.add("displayNoneItem");
        document.body.classList.remove("HiddenoverflowX");
    }

    const menu = [
        { label: 'Menu', value: 'Basic Report' },
        { label: 'Menu', value: 'Advance Report' },
        { label: 'Menu', value: "Accounting Recognition" },
        { label: 'Menu', value: "Royalty Expense" },
        { label: 'Menu', value: "Custom Reports" },
    ];

    const onChangeMenu = (e: any) => {
        console.log(e)
        setActiveMenu(e)

        if (e == "Basic Report") {
            activeSubTab = ""
            setactiveSubTab(activeSubTab)
        }

        if (e == "Advance Report") {
            activeSubTab = "Statements"
            setactiveSubTab(activeSubTab)
        }
    }

    return (
        <>
            {(subEntity) && <div id="myModal" className="modal pLarge ws-12 ">

                <a onClick={() => closeModal(true)} className="btn-xxs modalClose borderNone bgTransparent" style={{ position: "inherit" }} href="../../">
                    <i className="icon-close3 danger"></i>
                </a>

                <div className="allowHscroll allowVscroll full-height-vh95 ws-12 box" style={{ minHeight: "80%" }}>

                    <div className="12">
                        <div className="ws-2 pm borderReset full-height pLarge">
                            <div className="ws-12 text-center pLarge mtll mbl">
                                <img className="pull-none" src={korrectLogo} width={50} />
                            </div>

                            <ul className="main-menu pll prl ws-12">
                                <a className="full-width text-bold text-average text-m mtl ws-12 pbl">Report</a>
                                <ul >
                                    {menu?.map((value: any) => {
                                        return (<>
                                            {<li key={value.title} className={activeMenu === value.value ? " active" : ""}>
                                                <a className={"ws-12 text-sl text-normal"} onClick={() => { onChangeMenu(value.value) }}> {value.value} </a>
                                            </li>}
                                        </>)
                                    })}
                                </ul>
                            </ul>

                        </div>

                        <div className="ws-10 pm landing">

                            <div className="ws-12 ptxl mtl">
                                <span className="ws-12 text-bold text-xl">Report</span>
                                <span className="ws-12 ptl text-bold text-m turquoise">{activeMenu}</span>
                            </div>

                            {activeMenu == "Advance Report" && <div className="ws-12 mtl">
                                <a className={activeSubTab == "Statements" ? "btn-success active" : "btn-success"} onClick={() => { setactiveSubTab("Statements") }}> Statements </a>
                                <a className={activeSubTab == "Contracts" ? "btn-success active" : "btn-success"} onClick={() => { setactiveSubTab("Contracts") }}> Contracts </a>
                                <a className={activeSubTab == "Releases" ? "btn-success active" : "btn-success"} onClick={() => { setactiveSubTab("Releases") }}> Releases </a>
                                <a className={activeSubTab == "Tracks" ? "btn-success active" : "btn-success"} onClick={() => { setactiveSubTab("Tracks") }}> Tracks </a>
                                <a className={activeSubTab == "Checkings" ? "btn-success active" : "btn-success"} onClick={() => { setactiveSubTab("Checkings") }}> Checkings </a>

                            </div>}

                            {
                                (() => {

                                    if (activeMenu == "Basic Report" || activeMenu == "Advance Report" || activeMenu == "Custom Reports") {
                                        return (
                                            <div className=''> <BasicReport type={activeMenu} subType={activeSubTab} /> </div>

                                        )
                                    }

                                    if (activeMenu == "Accounting Recognition" || activeMenu == "Royalty Expense") {
                                        return (
                                            <div className=''> <AccountingRecognition_Template type={activeMenu} subType={activeSubTab} /> </div>

                                        )
                                    }


                                })()
                            }

                        </div>

                    </div>

                </div>
            </div>}
        </>
    )
}